module.exports = __webpack_public_path__ + "assets/img/thumb-Eimele-2-Landing-Page.acd3a5fa.webp";